import { useMemo } from "react";
import { FieldErrors, FieldValues } from "react-hook-form";


type Params<T extends FieldValues> = {
    errors: FieldErrors<T>;
    fields: (keyof T)[];
    focusableFieldName?: keyof T;
}
export function useFormErrors<T extends FieldValues>({ errors, fields, focusableFieldName }: Params<T>) {
    const shouldShowErrorTooltipFields = useMemo(() => {
        const result = fields.reduce(
            (acc, fieldName) => {
                const currentFieldHasError = Boolean(errors[fieldName]);
                const currentFieldHasFocus = focusableFieldName === fieldName;

                acc[fieldName] = currentFieldHasError && currentFieldHasFocus;

                return acc;
            },
            {} as Record<keyof T, boolean>,
        );

        return result;
    }, [errors, fields, focusableFieldName]);

    return {
        shouldShowErrorTooltipFields,
    }
}